import type { FaireProductEntity } from "../../entity_types/product";

export const p_nfn7vsv973: FaireProductEntity = {
  token: "p_nfn7vsv973",
  type: "product",
  name: "Monte's Marinara Tomato Sauce 16oz",
  brandToken: "b_7oxj1f2e63",
  brandName: "Monte’s Fine Foods",
  imageUrl:
    "https://cdn.faire.com/fastly/025d047d829b1fcae724c1c79ad1bfef185b5b5f5f2a21cb4ceb160895c3ce4a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cd0ac02c22ce94984222c094411da61fa021a7b2ebfb90c286fd29d24c86ee52.png",
    "https://cdn.faire.com/fastly/616678c37d2b6d8b8d6fe1bf8839375ee1a66b10d020a592ec10cd0d43d9f78c.png",
    "https://cdn.faire.com/fastly/413c806e329c9be854dcf4c918fef0a8170fdb60998b63a20ee66fa054b462a8.png",
  ],
  priceDollars: 5,
  description:
    "Same great recipe, just thicker!\n\nMonte's Marinara is a classic Italian tomato sauce that delivers simplicity and flavor in perfect harmony. Made with ripe tomatoes, extra virgin olive oil, and a blend of fresh herbs, it’s a versatile staple for countless dishes.\n\nWe are Proudly a 100% Clean Label Product. We use only natural ingredients.\n\nNo tomato blends, pastes, starches, fillers, artificial additives, colors, dried herbs, or added sugars.\n\nCertified Kosher, Vegan & Gluten free.",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:32.100Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
